module.exports = __webpack_public_path__ + "static/Mural.4fd2e895.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/blog/art-in-neighborhoods/Mural.jpg
// module id = 473
// module chunks = 107818501498521